import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { Tabs, Tab, Typography, Button } from '@mui/material';
import { withTheme } from '@mui/styles';
import ReactJson from 'react-json-view';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import { FileCopy, Replay, Edit } from '@mui/icons-material';
import { copyToClipboard, renderItem, unwrapItem } from './utils';
import FixItemTable from './fix/FixItemTable';

const detailsTab = {
	// height: '100%',
	background: '#0000',
	fontSize: '13px'
};

const switchStyle = {
	height: '36px',
	minHeight: '36px',
};

const JSON_TAB = 'JSON_TAB';
const RAW_TAB = 'RAW_TAB';
const FIX_TAB = 'FIX_TAB';
const EMPTY_TAB = 'EMPTY_TAB';

class DetailsTabs extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			tabType: props.isFix ? FIX_TAB : JSON_TAB,
			item: null
		};

		this.handleChange = this.handleChange.bind(this);
	}

	setItem(item) {
		this.setState({ item });
	}

	handleChange(event, tabType) {
		this.setState({ tabType });
	}

	async saveToClipboard() {
        if(!copyToClipboard(renderItem(this.state.item))) {
            if(this.rawRef) {
                window.getSelection().selectAllChildren(ReactDOM.findDOMNode(this.rawRef));
                document.execCommand('copy');
            }
        }
	}

	renderDetailsTab(tabType) {
		switch (tabType) {
		case JSON_TAB:
			return (
				<ReactJson
					theme={this.props.theme.palette.json}
					style={{ ...detailsTab }}
					name={false}
					collapsed={5}
					displayDataTypes={false}
					enableClipboard={true}
					src={unwrapItem(this.state.item).content}
				/>
			);
		case RAW_TAB:
			return (
				<AutoSizer>
					{({ height, width }) => (
						<Typography 
							ref={(ref) => { this.rawRef = ref; }}
							variant="body1" 
							style={{ ...detailsTab, whiteSpace: 'pre-wrap', overflow: 'auto', fontFamily: 'monospace', height: height, width: width }}
						>
							{renderItem(this.state.item)}
						</Typography>
					)}
				</AutoSizer>
			);
		case FIX_TAB:
			return (
				<FixItemTable fixMessage={this.state.item} />
			);
		default:
			return <div />;
		}
	}

	render() {
		let data = this.state.item;

		const rawOnly = !this.props.isFix && data && ((typeof data.message) !== 'object');
		const tabType = rawOnly ? RAW_TAB : this.state.tabType;

		const fixTab = <Tab style={switchStyle} label="TABLE" value={FIX_TAB}/>;
		const jsonTab = <Tab style={switchStyle} label="JSON" disabled={rawOnly} value={JSON_TAB} />;

		return (
			<div style={{ display: 'flex', flexFlow: 'column', height: '100%', overflow: 'hidden', background: this.props.theme.palette.background.paper }}>
				<div style={{ display: 'flex', flexFlow: 'row',  flex: '0 1 auto', background: this.props.theme.palette.background.header, borderBottom: this.props.theme.border }}>
					<Tabs style={{...switchStyle, flex: '1 1 auto'}} value={tabType} onChange={this.handleChange}>
						{this.props.isFix ? fixTab : jsonTab}
						<Tab style={switchStyle} label="Raw" value={RAW_TAB} />
					</Tabs>
					{data && data?.extra?.request && this.props.editRequest && <Button style={{flex: '0 0 auto'}} onClick={() => this.props.editRequest(data)} color="primary"><Edit/>Edit</Button>}
					{data && data?.extra?.request && this.props.replayRequest && <Button style={{flex: '0 0 auto'}} onClick={() => this.props.replayRequest(data)} color="primary"><Replay/>Repeat</Button>}
					{data && <Button style={{flex: '0 0 auto'}} onClick={() => this.saveToClipboard()} color="primary"><FileCopy/>Copy</Button>}
				</div>
				<div style={{ overflow: 'auto', flex: '1 1 auto' }}>
					{this.renderDetailsTab(data ? tabType : EMPTY_TAB)}
				</div>
			</div>
		);
	}
}

DetailsTabs.propTypes = {
	theme: PropTypes.object,
	replayRequest: PropTypes.func,
	editRequest: PropTypes.func,
	isFix: PropTypes.bool,
};

export default withTheme(DetailsTabs);
